<template>
  <v-btn icon color="primary" @click="watchlistUpdate">
    <v-icon>{{ is_watchlisted ? "mdi-star" : "mdi-star-outline" }}</v-icon>
  </v-btn>
</template>

<script>
import { axios_get, axios_post, axios_delete } from "../services/vt_service";
import { watchlist } from "../services/common";

export default {
  name: "AddToWatchlist",
  props: {
    deviceId: {
      type: String,
      required: true,
    },
  },
  watch: {},
  data: function () {
    return {
      watchlist: [],
    };
  },
  created() {},
  mounted() {
    this.getWatchlistedDevices();
  },
  methods: {
    watchlistUpdate() {
      this.is_watchlisted ? this.deleteFromWatchlist() : this.addToWatchlist();
    },
    async addToWatchlist() {
      var data = { DeviceID: this.deviceId };
      await axios_post(watchlist.add_to_watchlist, data);
      this.watchlist.push(this.deviceId);
    },
    async deleteFromWatchlist() {
      var data = { DeviceID: this.deviceId };
      await axios_delete(watchlist.delete_from_watchlist, {}, data);
      this.watchlist.splice(this.watchlist.indexOf(this.deviceId), 1);
    },
    async getWatchlistedDevices() {
      let response = await axios_get(watchlist.get_device_watchlist);
      this.watchlist =
        response &&
        response.map((elem) => {
          return elem["DeviceID"];
        });
    },
  },
  computed: {
    is_watchlisted: function () {
      return this.watchlist && this.watchlist.length > 0 ? this.watchlist.indexOf(this.deviceId) != -1 : false;
    },
  },
};
</script>
<style scoped>
::v-deep .filter-autocomplete.v-text-field .v-input__control .v-input__slot .v-select__slot {
  height: auto !important;
}

.filter-autocomplete {
  font-size: 12px !important;
}
::v-deep .filter-autocomplete .v-label {
  font-size: 12px !important;
  line-height: 14px !important;
}

::v-deep .filter-autocomplete .mdi.mdi-menu-down:before {
  display: none;
}
</style>
